let launchDarkly = {};
let cognito = {};
let appsync = {};

cognito = {
  REGION: 'us-west-2',
  USER_POOL_ID: 'us-west-2_c0F8P3ojn',
  APP_CLIENT_ID: '38tta775htamcktvkoe5e4p60',
  IDENTITY_POOL_ID: 'us-west-2:0876d994-d63d-40c6-a174-e3bda353247d'
};
launchDarkly = {
  clientId: '5b588b97b5f7552ef1123530'
};
appsync = {
  'aws_appsync_graphqlEndpoint': 'https://hevob4dj6zczbeqxk545kyori4.appsync-api.us-west-2.amazonaws.com/graphql',
  'aws_appsync_region': 'us-west-2',
  'aws_appsync_authenticationType': 'API_KEY',
  'aws_appsync_apiKey': 'da2-leul6z7vhrdnxfmdhpatei6rci'
};

if (process.env.REACT_APP_STAGE === 'dev') {
  cognito = {
    REGION: 'us-west-2',
    USER_POOL_ID: 'us-west-2_94KXV27rr',
    APP_CLIENT_ID: '2esc54olafirkbcs2fda2cb131',
    IDENTITY_POOL_ID: 'us-west-2:33217e3f-d503-4426-90dc-ae5cf786aa2e'
  };
  launchDarkly = {
    clientId: '5b588b97b5f7552ef112352f'
  };
  appsync = {
    'aws_appsync_graphqlEndpoint': 'https://cd2sz7lcmbhc5ejo5ltf3ua5ui.appsync-api.us-west-2.amazonaws.com/graphql',
    'aws_appsync_region': 'us-west-2',
    'aws_appsync_authenticationType': 'API_KEY',
    'aws_appsync_apiKey': 'da2-km67njb3ubhrxfof7t4ua62mz4'
  };
}

export default {
  cognito,
  launchDarkly,
  appsync
};
